<template>
  <div>
    <template v-if="tabs.length < 3">
      <Tabs
        :tabs="tabs"
        :has-router-view="false"
      >
        <slot />
      </Tabs>
    </template>

    <template v-else>
      <b-dropdown
        v-if="items.length > 0"
        variant="outline-primary"
        right
        class="folder-selector"
        size="sm"
      >
        <template slot="button-content">
          <div class="d-inline-flex align-items-center">
            <font-awesome-icon
              icon="folder"
              class="mr-2"
            /> {{ (selected == '')? 'All' : selected.name }}
          </div>
        </template>
        <b-dropdown-item @click="selected = ''">
          All
        </b-dropdown-item>
        <b-dropdown-item
          v-for="(item, index) in items"
          :key="index"
          @click="selected = item"
        >
          {{ item.name }}
        </b-dropdown-item>
      </b-dropdown>

      <slot />
    </template>
  </div>
</template>

<script>
export default {
  name: 'FolderSelector',
  data() {
    return {
      selected: '',
    };
  },
  computed: {
    tabs() {
      const tabs = this.items.map((i) => ({
        path: `/collateral/folder/${i.pk}`,
        title: i.name,
      }));

      tabs.unshift({
        path: '/collateral/',
        title: 'All',
      });

      return tabs;
    },
    items() {
      return this.$store.state.folders.items;
    },
  },
  watch: {
    selected() {
      console.log(this.selected);
      if (this.selected) {
        this.$router.push(`/collateral/folder/${this.selected.pk}`);
      } else {
        this.$router.push('/collateral/');
      }
    },
  },
  mounted() {
    this.$store.dispatch('folders/getAll');
  },
};
</script>

<style lang="scss">
.folder-selector .btn{
    border: none !important;
}
</style>
